<template>
    <div class="w-full bg-gray-200 min-h-screen">
        <div class="text-left px-4 py-4 bg-gray-400 sticky top-0 z-50 flex items-center">
            <div @click="$emit('close')" class="flex items-center flex-1">

                <IconChevronLeftOutline class="w-8 h-8 mr-2"></IconChevronLeftOutline>

                {{_('Return to menu') }}
                
            </div>

            <div v-if="cart.length > 0" class="font-bold text-xl">${{ total.toFixed(2) }}</div>
            
        </div>


        <div class="bg-white shadow overflow-hidden sm:rounded-md">
            <div v-if="cart.length === 0" class="min-h-screen italic text-gray-500 text-xl text-center py-10">
                {{_('Your cart is empty') }}
            </div>
            <ul v-else class="divide-y divide-gray-200">
                <li v-for="(item, index) in cart" :key="`cat_${index}`">
                    
                        <div class="px-4 py-4 sm:px-6">
                            <div class="flex items-start">
                                <div class="flex-1">

                                    <p class="text-sm font-medium text-indigo-600 truncate">
                                        {{ item.original.name }}
                                    </p>
                                    
                                    <div class="">
                                        <p :key="`${line}${index}`" v-for="(line, index) in item.remarks" class="flex items-center text-sm text-gray-700">
                                            {{ line }}
                                        </p>
                                    </div>
                                    
                                </div>
                                
                                <div class="ml-2 flex-shrink-0 text-right">
                                    <p class="px-2 mb-2 inline-flex text-sm leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                                        ${{ (item.price * item.data.qty).toFixed(2) }}
                                        <template v-if="!item.original.taxable">*</template>
                                    </p>

                                    <div></div>

                                    
                                    
                                </div>
                            </div>
                            <div class="flex items-start justify-between">
                                <div class="mt-2 flex items-center text-sm text-gray-700 sm:mt-0">
                                    
                                    <div class="mr-2">${{ item.price }}</div>
                                    
                                    <Incrementor v-if="!item.original.limited" class="flex-1" v-model="item.data.qty" 
                                                 :max="item.original.quantity - totalItemsOf(item.original.id) + item.data.qty"
                                                 :min="1"></Incrementor>

                                </div>

                                <div class="text-md flex my-4">
                                    <div class="flex-1"></div>
                                    <div class="mr-4" @click="$emit('edit', {item, index})">
                                        <IconPencilOutline></IconPencilOutline>

                                    </div>
                                    <div @click="remove(index)">
                                        <IconTrashOutline></IconTrashOutline>

                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    
                </li>

            </ul>
        </div>

        <div v-if="has_nontaxable" class="text-xs text-gray-800 italic px-4">* Non-taxable</div>
        
        <div v-if="cart.length > 0">
            
        <div class="px-4 my-4">
            <div v-if="discount > 0" class="flex items-center py-2 border-b text-green-500 font-medium border-gray-500 my-2"><div class="flex-1">{{ _('Discount') }}:</div><div>${{ discount.toFixed(2) }}</div></div>

            <div class="flex items-center py-2 border-b border-gray-500 my-2"><div class="flex-1">{{ _('Subtotal') }}:</div><div>${{ (subtotal - fees - upsell_fee).toFixed(2) }}</div></div>
            <div class="flex items-center py-2 border-b border-gray-500 my-2"><div class="flex-1">{{ _('Livro Fee') }}:</div><div>
                
                ${{ fees }}
            
                <span v-if="upsell_fee > 0"  @click="$emit('optout')" class="cursor-pointer inline-block bg-green-300 text-green-800 rounded px-1">  + ${{ upsell_fee }}
                    <IconTrashOutline size="4"></IconTrashOutline>
                </span>
            
            </div></div>
            <div class="flex items-center py-2 border-b border-gray-500 my-2"><div class="flex-1">{{ _('GST 5%') }}:</div><div>${{ tps.toFixed(2) }}</div></div>
            <div class="flex items-center py-2 border-b border-gray-500 my-2"><div class="flex-1">{{ _('QST 9.975%') }}:</div><div>${{ tvq.toFixed(2) }}</div></div>
            <div v-if="credits > 0" class="flex items-center py-2 border-b text-green-500 font-medium border-gray-500 my-2"><div class="flex-1">{{ _('Credit') }}:</div><div>${{ credits.toFixed(2) }}</div></div>
            <div class="flex items-center py-2 border-b border-gray-500 my-2"><div class="flex-1">{{ _('Total') }}:</div><div>${{ (total - credits).toFixed(2) }}</div></div>
            
            
        </div>
        
        
        <div v-if="minimum && (subtotal - fees - upsell_fee) < minimum"  class="p-4 italic text-gray-800 text-xl text-center">
            
            {{ _('Your sub-total needs to exceed $%s as a minimum order.').split("%s").join(minimum.toFixed(0)) }}

<!--            You're missing $x.xx to meet the minimum.-->
<!--            Il manque $x.xx dans votre panier-->
            
        </div>
        
        
            
            <template v-if="!minimum || (subtotal - fees - upsell_fee) >= minimum">

                <div  @click="$emit('order', 'cash')" class="bg-indigo-600 mx-4 rounded-lg px-6 py-4 uppercase font-medium text-white text-center mt-8">


                    {{  _('Pay with CASH') }}

                </div>

                <div  @click="$emit('order', 'card')" class="bg-indigo-600 mx-4 rounded-lg px-6 py-4 uppercase font-medium text-white text-center mt-8">


                    {{  _('Pay with CARD') }}

                </div>

                <p class="px-8 text-xs text-red-600 my-4">
                    * {{ _('All our drivers are equipped with a Moneris terminal, we accept; Debit, Credit and Interac at the door!') }}
                </p>

                <p class="px-8 text-xs pb-10">
                    {{ _('All sales are final and cannot be canceled. Card transactions are paid at the door. Card must be present.' )}}
                </p>



            </template>
           

           
            
        </div>
        

    </div>
</template>

<script>
import Incrementor from "../../Shared/Incrementor";
import IconChevronLeftOutline from "../../../icons/outline/IconChevronLeftOutline";
import IconPencilOutline from "../../../icons/outline/IconPencilOutline";
import IconTrashOutline from "../../../icons/outline/IconTrashOutline";
import {lang} from "../../lang";
export default {
  name: "Cart",
    components: {IconTrashOutline, IconPencilOutline, IconChevronLeftOutline, Incrementor},
    props: ['value', 'fees', 'minimum', 'discount', 'credits', 'rebate', 'app_locale', 'tps', 'tvq', 'subtotal', 'total', 'upsell_fee'],
    data() {
      console.log(this.value);
      return {
          cart: this.value,
      }
    },
    
    
    computed: {
        has_nontaxable() {
            return this.cart.filter(item => item.original.taxable === false).length > 0;
        }
      
    },
    
    methods: {


        totalItemsOf(id) {
            return this.cart.filter(row => row.original.id === id).reduce((c, row) => c + row.data.qty, 0)
        },
      
      inc(item) {
          item.data.qty++;
          this.$emit('input', this.cart);
      },
        
        dec(item) {
          if (item.data.qty > 1) {
              item.data.qty--;
          }
          this.$emit('input', this.cart);
        },
        
        remove(index) {
          this.cart.splice(index, 1);
            this.$emit('input', this.cart);
        }
      ,
        _(k) {
            return lang(k, this.app_locale === 'fr_CA' ? 'fr' : 'en');
        }
      
    }
}
</script>

<style scoped>

</style>
